/* eslint-disable import/no-duplicates */
import { useMsal } from "@azure/msal-react";
import { useEffect, useState, useCallback, useRef } from "react";
import { ThemeProvider } from "styled-components";
import styled from "styled-components";
import { startOfMonth, endOfMonth, format } from "date-fns";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ReactComponent as NotificationIcon } from "../../assets/icons/Bell.svg";
import NotificationService from "../../service/Docente/NotificationService";
import GenericUtils from "../../utils/GenericUtils";
import Dialog from "../../components/Dialog";
import DialogStyles from "../../styles/components/DialogStyles";
import ButtonStyles from "../../styles/components/ButtonStyles";
import { TipoNotificacaoEnum } from "../../model/Enums/TipoNotificacaoEnum";
import {
    StyledFormCheckNotification,
    StyledLabel,
} from "../../styles/MainStyles";

import HomeStyles from "../../styles/pages/HomeStyles";
import { InformationIcon } from "../../components/Icons";
import BotaoStatus from "./BotaoStatus";
import { axiosGetRequest } from "../../api/ApiClient";
import CalendarComponent from "../../components/CalendarComponent/CalendarComponent";
import DadosPendentesComponent from "../../components/DadosPendentes/DadosPendentesComponent";
import ExtratoMensal from "../../components/ExtratoMensal/ExtratoMensal";
import { CartoesDTO } from "../../components/ExtratoMensal/IExtratoMensal";

type NotificationWithSubjectType = [string, string];

const { StyledTitle } = HomeStyles;

const { StyledModalTitle, StyledModalText, StyledContainerButton } =
    DialogStyles;

const { BtnPrimary } = ButtonStyles;

const ContainerExtratoCalendario = styled.div`
    display: flex;
    margin-top: 32px;
    flex-wrap: wrap;
    @media (max-width: 768px) {
        flex-direction: column;
    }
`;

const LeftContent = styled.div`
    width: 55%;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

const RightContent = styled.div`
    width: 45%;
    @media (max-width: 768px) {
        width: 100%;
        margin-top: 16px;
    }
`;

const CustomTooltip = styled(Tooltip)`
    --bs-tooltip-opacity: 1 !important;

    .tooltip-inner {
        max-width: 441px;
        background-color: #ffffff !important;
        color: #404040;
        font-family: "Source Sans Pro", sans-serif;
        font-weight: 600;
        font-size: 15px;
        line-height: 156%;
        letter-spacing: 0px;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.12);
        border-radius: 8px;
        z-index: 8000;
        opacity: 1 !important;
    }
    .tooltip-arrow::before {
        border-top-color: #ffffff !important;
        opacity: 1 !important;
    }
`;

function MeuPainel() {
    const { instance } = useMsal();
    const [notifications, setNotifications] = useState<
        Array<NotificationWithSubjectType>
    >([]);
    const [blockingPeriods, setBlockingPeriods] = useState<any[]>([]);
    const [checked, setChecked] = useState(false);
    const [forceUpdate, setForceUpdate] = useState(false);
    const [validCheck, setValidCheck] = useState(true);
    const account = GenericUtils.getUserAccount();
    const user = GenericUtils.getUser();
    const theme = {};
    const fullName = account?.name;
    const firstName = (fullName || "").split(" ");
    const userfirstName = firstName[0] || "docente";
    const [pendingData, setPendingData] = useState<{
        pendenciasAgenda: {
            alocacao: {
                quantidade: number;
            };
            checkin: {
                quantidade: number;
                cartoesVencidos: any[];
            };
            antecipacaoSemVinculo: {
                quantidade: number;
                cartoesAntecipacao: any[];
            };
        };
    } | null>(null);

    const formatData = "yyyy-MM-dd";
    type Holiday = {
        calendarioFeriadoId: number;
        dataFeriado: string;
        tipoFeriado: string;
        nomeFeriado: string;
        motivoRecesso: string;
        campus: string;
    };

    type GestaoAtividade = {
        calendarioGestaoAtividadesId: number;
        created: string;
        updated: string;
        kind: string;
        selfLink: string;
        dataSelecionadaNoCalendario: string;
        periodoInicioReferencia: string;
        periodoFimReferencia: string;
        dataLimiteJustificativa: string;
        dataLimiteAprovacao: string;
        matriculaQuemInseriu: string;
        nomeQuemInseriu: string;
    };

    const [holidaysData, setHolidaysData] = useState<Holiday[]>([]);
    const [gestaoAtividadeData, setGestaoAtividadeData] = useState<
        GestaoAtividade[]
    >([]);
    const [extrato, setExtrato] = useState<CartoesDTO | null>(null);

    async function getNotificationsBlock(
        matriculaAdp: string,
        limpar: boolean
    ) {
        const response = await NotificationService.getNotifications(
            matriculaAdp,
            TipoNotificacaoEnum.PeriodoBloqueioPlanoAtividade,
            instance,
            limpar
        );

        if (GenericUtils.isSuccessStatus(response?.status)) {
            setBlockingPeriods(
                response?.data?.map((item: any) => item.mensagem)
            );
        }
    }

    function getNewGetWorkLoadValue() {
        return {
            docenteId: 0,
            letivaBase: 0,
            horaLetivaEventual: 0,
            horaLetivaSubstituicao: 0,
            naoLetivaBase: 0,
            horaNaoLetivaEventual: 0,
            horaNaoLetivaSubstituicao: 0,
            cargaHorariaTotal: 0,
            dataUpdate: "",
        };
    }

    const acessToken = GenericUtils.getAccessTokenDocente();
    const { instance: msalAplication } = useMsal();
    const [statusTachAtual, setStatusTachAtual] = useState<any>("Pendente");
    const [statusTachAtivo, setStatusTachAtivo] = useState<boolean>();
    const [workloadValue, setGetWorkloadValue] = useState(
        getNewGetWorkLoadValue()
    );

    function updateTachStatus(planList: any[], currentWorkload: any) {
        const sortedPlans = [...planList].sort(
            (a, b) => b.planoAtividadeDocenteId - a.planoAtividadeDocenteId
        );
        const lastPlan = sortedPlans[0];

        if (lastPlan.planoAtividadeDocenteStatus === "Aprovado") {
            return "Aprovado";
        }

        if (
            lastPlan.planoAtividadeDocenteStatus === "Rascunho" ||
            lastPlan.planoAtividadeDocenteStatus === "Inconsistente" ||
            lastPlan.planoAtividadeDocenteStatus === "Reprovado"
        ) {
            return "Pendente";
        }

        if (lastPlan.planoAtividadeDocenteStatus === "Aguardando Aprovação")
            return "Analise";

        if (
            lastPlan.planoAtividadeDocenteStatus === "Finalizado" &&
            lastPlan.cargaHorariaTotal !== currentWorkload.cargaHorariaTotal &&
            (currentWorkload.naoLetivaBase > 0 ||
                currentWorkload.horaNaoLetivaEventual > 0 ||
                currentWorkload.horaNaoLetivaSubstituicao > 0)
        ) {
            return "Pendente";
        }
        return "Dispensado";
    }

    async function getTeacherData() {
        try {
            const [workloadResponse, activityPlansResponse] = await Promise.all(
                [
                    axiosGetRequest(
                        `/docente/v1/professores/${user.docente.docenteID}/carga-horaria`,
                        acessToken,
                        msalAplication
                    ),
                    axiosGetRequest(
                        `/docente/v1/planosatividade/professores/${user.docente.docenteID}`,
                        acessToken,
                        msalAplication
                    ),
                ]
            );

            if (GenericUtils.isSuccessStatus(workloadResponse)) {
                setGetWorkloadValue(workloadResponse.data);
            }

            if (
                GenericUtils.isSuccessStatus(activityPlansResponse) &&
                activityPlansResponse.data.length
            ) {
                const activityPlans = activityPlansResponse.data;

                const statusTach = updateTachStatus(
                    activityPlans,
                    workloadResponse.data
                );
                setStatusTachAtual(statusTach);
                setStatusTachAtivo(true);
            } else if (
                workloadResponse.data.naoLetivaBase +
                    workloadResponse.data.horaNaoLetivaEventual +
                    workloadResponse.data.horaNaoLetivaSubstituicao >
                0
            ) {
                setStatusTachAtual("Pendente");
                setStatusTachAtivo(true);
            } else {
                setStatusTachAtual("Dispensado");
                setStatusTachAtivo(true);
            }
        } catch (requestError) {
            console.error("Erro ao buscar dados do docente:", requestError);
        }
    }

    async function getPendingData() {
        const response = await axiosGetRequest(
            `/docente/v1/painelDocente/${user.docente.matriculaAdp}`,
            // `/docente/v1/painelDocente/${90009062}`, // Cartões pendentes de alocação com 1
            // `/docente/v1/painelDocente/${1576}`, // Cartões pendentes de check-in com 6
            // `/docente/v1/painelDocente/${8975}`, // Cartões de antecipação sem vínculo com 6
            acessToken,
            instance
        );
        setPendingData(response.data);
    }

    const getHolidaysCallback = useCallback(
        async (mes: number | null = null, ano: number | null = null) => {
            const anoFinal = ano ?? new Date().getFullYear();
            const mesFinal = mes ?? new Date().getMonth() + 1;

            const data = new Date(anoFinal, mesFinal - 1, 1);
            const inicio = startOfMonth(data);
            const fim = endOfMonth(data);

            const dataInicialFormatada = format(inicio, formatData);
            const dataFinalFormatada = format(fim, formatData);

            const response = await axiosGetRequest(
                `/docente/v1/feriados?data_inicial=${dataInicialFormatada}&data_final=${dataFinalFormatada}`,
                acessToken,
                instance
            );

            if (Array.isArray(response.data)) {
                setHolidaysData(response.data);
            } else {
                setHolidaysData([]);
            }
        },
        [acessToken, instance]
    );
    const getGestaoAtividades = useCallback(
        async (mes: number | null = null, ano: number | null = null) => {
            const anoFinal = ano ?? new Date().getFullYear();
            const mesFinal = mes ?? new Date().getMonth() + 1;

            const data = new Date(anoFinal, mesFinal - 1, 1);
            const inicio = startOfMonth(data);
            const fim = endOfMonth(data);

            const dataInicialFormatada = format(inicio, formatData);
            const dataFinalFormatada = format(fim, formatData);

            const response = await axiosGetRequest(
                `/docente/v1/calendariogestaoatividades?dataRange=${dataInicialFormatada}...${dataFinalFormatada}`,
                acessToken,
                instance
            );
            const retorno = response?.data?.calendariosGestaoAtividades;
            if (Array.isArray(retorno)) {
                setGestaoAtividadeData(retorno);
            } else {
                setGestaoAtividadeData([]);
            }
        },
        [acessToken, instance]
    );

    const getExtratoPorMes = useCallback(
        (mes: number, ano: number) => {
            const mesFormatado = (mes + 1).toString().padStart(2, "0");
            axiosGetRequest(
                // `/docente/v1/painel/extratos/522/mes-ano/${mesFormatado}-${ano}`,
                // `/docente/v1/painel/extratos/8/mes-ano/${mesFormatado}-${ano}`,
                `/docente/v1/painel/extratos/${user.docente.docenteID}/mes-ano/${mesFormatado}-${ano}`,
                // `/docente/v1/painel/extratos/1310/mes-ano/07-2025`,
                acessToken,
                instance
            )
                .then((response) => {
                    const retorno = response.data;
                    if (retorno && typeof retorno === "object") {
                        setExtrato(retorno);
                    } else {
                        setExtrato(null);
                    }
                })
                .catch((error) => {
                    setExtrato(null);
                });
        },
        [acessToken, instance]
    );
    useEffect(() => {
        if (!forceUpdate) {
            setForceUpdate(true);
        }
    }, [forceUpdate]);

    const alreadyFetchedRef = useRef(false);

    useEffect(() => {
        const fetchData = async () => {
            if (user && !alreadyFetchedRef.current) {
                alreadyFetchedRef.current = true;

                try {
                    await Promise.all([
                        getTeacherData(),
                        getPendingData(),
                        getHolidaysCallback(),
                        getGestaoAtividades(),
                    ]);
                } catch (error) {
                    console.error("Erro ao carregar dados do painel:", error);
                }
            }
        };

        fetchData();
    }, [user]);

    const handleNotificationBlock = () => {
        setValidCheck(false);
        if (checked) {
            getNotificationsBlock(user?.docente?.matriculaAdp, true).then(() =>
                setBlockingPeriods([])
            );
        } else {
            setBlockingPeriods([]);
        }
    };

    const handleNotification = () => {
        setNotifications([]);
        setBlockingPeriods([]);
        setValidCheck(false);
    };

    const shouldShowTachStatus = (): boolean => {
        const dataAtual = new Date();
        const dataLimite = new Date("2026-07-13T00:00:00");
        return dataAtual < dataLimite;
    };

    const dialogNotificationBlock = (
        <Dialog
            openModal={!!blockingPeriods.length}
            onHide={handleNotification}
            size="width-300"
            modalIcon={<NotificationIcon />}
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                Período de edição TACH
            </StyledModalTitle>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                {blockingPeriods[0]}
            </StyledModalText>

            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <StyledFormCheckNotification
                        type="checkbox"
                        onChange={(event: any) =>
                            setChecked(event.target.checked)
                        }
                    />
                    <StyledLabel
                        marginB={0}
                        style={{
                            fontSize: 16,
                            fontWeight: 400,
                            lineHeight: "48px",
                            color: "#8A0538",
                            marginLeft: 8,
                        }}
                    >
                        Não exibir novamente
                    </StyledLabel>
                </div>
            </StyledModalText>
            <StyledContainerButton>
                <BtnPrimary onClick={handleNotificationBlock}>Ok</BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );

    const dialogNotificationChange = (
        <Dialog
            openModal={!!notifications.length}
            onHide={handleNotification}
            size="width-300"
        >
            <StyledModalTitle style={{ fontSize: "22px" }}>
                {notifications && notifications.length > 0
                    ? notifications[0][0]
                    : "Gestão de Atividades"}
            </StyledModalTitle>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                {notifications &&
                    notifications.length > 0 &&
                    notifications[0][1]}
            </StyledModalText>
            <StyledModalText
                style={{ marginTop: "24px", marginBottom: "24px" }}
            >
                Atenciosamente.
            </StyledModalText>

            <StyledContainerButton>
                <BtnPrimary onClick={handleNotification}>Ok</BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );

    return (
        <ThemeProvider theme={theme}>
            <div style={{ marginLeft: "40px" }}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <div
                        className="saudacao"
                        style={{
                            maxWidth: "634px",
                            alignItems: "left",
                            padding: "48px 0 0 0",
                            marginBottom: "24px",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            <StyledTitle style={{ margin: "0 0 10px 0" }}>
                                Olá, {userfirstName}!
                            </StyledTitle>
                            <div
                                style={{
                                    boxSizing: "border-box",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "0px 16px",
                                    gap: "8px",
                                    minHeight: "40px",
                                    height: "100%",
                                    border: "1px solid #E4E4E4",
                                    borderRadius: "32px",
                                    textAlign: "center",
                                    fontSize: "15px",
                                    fontWeight: "normal",
                                }}
                            >
                                Matrícula {user?.docente?.matriculaAdp}
                            </div>
                        </div>

                        <div>
                            Aqui você encontra as ações que precisam da sua
                            atenção no TACH e na sua Agenda.
                        </div>
                    </div>

                    <div
                        className="meu-tach"
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            backgroundColor: "#FAFAFA",
                            height: "144px",
                            gap: "60px",
                            padding: "24px",
                            borderRadius: "24px",
                        }}
                    >
                        <div>
                            <h3
                                style={{
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                    fontStyle: "normal",
                                    fontSize: "20px",
                                    lineHeight: "140%",
                                    letterSpacing: "0px",
                                    verticalAlign: "middle",
                                    color: "#570013",
                                }}
                            >
                                Meu TACH
                            </h3>
                            <h6
                                style={{
                                    fontFamily: "Source Sans Pro",
                                    fontWeight: "600",
                                    fontStyle: "normal",
                                    fontSize: "17px",
                                    lineHeight: "150%",
                                    letterSpacing: "0px",
                                    verticalAlign: "middle",
                                    color: "#383838",
                                }}
                            >
                                Status semanal TACH{" "}
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <CustomTooltip id="tooltip-info">
                                            <p>
                                                As atividades que farão parte do
                                                seu TACH e serão desempenhadas
                                                no semestre letivo devem ser
                                                alinhadas com o seu coordenador.
                                                Status do TACH:
                                            </p>
                                            <p>
                                                {" "}
                                                <strong>Aprovado:</strong>{" "}
                                                Indica que o TACH foi elaborado
                                                e aprovado pela coordenação.
                                            </p>
                                            <p>
                                                <strong>Pendente:</strong>{" "}
                                                Indica que o TACH precisa ser
                                                elaborado ou caso já tenha sido
                                                analisado pela coordenação foi
                                                identificado necessidade de
                                                ajustes.
                                            </p>
                                            <p>
                                                <strong>
                                                    Aguardando Aprovação:
                                                </strong>{" "}
                                                O TACH foi elaborado e está
                                                aguardando a aprovação da
                                                coordenação.
                                            </p>
                                        </CustomTooltip>
                                    }
                                >
                                    <InformationIcon
                                        style={{ marginLeft: "10px" }}
                                    />
                                </OverlayTrigger>
                            </h6>
                        </div>
                        {!shouldShowTachStatus() && (
                            <div className="botaoStatus">
                                {statusTachAtivo ? (
                                    <BotaoStatus status={statusTachAtual} />
                                ) : (
                                    <div
                                        className="spinner-border text-secondary"
                                        role="status"
                                    >
                                        <span className="visually-hidden">
                                            Carregando...
                                        </span>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {!!notifications.length && dialogNotificationChange}
            {!!blockingPeriods.length && dialogNotificationBlock}
            <div style={{ marginLeft: "40px" }}>
                <DadosPendentesComponent pendingData={pendingData} />
                <ContainerExtratoCalendario>
                    <LeftContent>
                        <ExtratoMensal
                            extrato={extrato}
                            onChangeMes={(mes, ano) =>
                                getExtratoPorMes(mes, ano)
                            }
                        />
                    </LeftContent>
                    <RightContent>
                        <CalendarComponent
                            holidaysData={holidaysData}
                            gestaoAtividadeData={gestaoAtividadeData}
                            onChangeMes={(mes, ano) => {
                                getHolidaysCallback(mes, ano);
                                getGestaoAtividades(mes, ano);
                            }}
                        />
                    </RightContent>
                </ContainerExtratoCalendario>
            </div>
        </ThemeProvider>
    );
}

export default MeuPainel;
